import { Store } from 'vuex';
import { inject, injectable } from 'inversify-props';
import { ICommand, mcDate } from '@/utils';
import { MealCountKey } from '@/models';
import { IState } from '@/store';

/** Finds a given list of items from store */
@injectable()
export class FindMealsCommand implements ICommand<MealCountKey[]> {
  @inject() private store!: Store<IState>;

  run(request: MealCountKey[]) {
    const result = this.store.state.meals.mealCountDtos.filter(m =>
      request.some(key => {
        return m.siteId == key.siteId
          && m.programId == key.programId
          && m.mealTypeId == key.mealTypeId.toUpperCase()
          && mcDate.toShortDate(m.mealServiceDate) == key.mealServiceDate;
      }));
    return result;
  }
}
